/**
 * Kleine opmaakhulpen voor rechts: bedragen, dagen, woorden.
 *
 * Let op bij een toets: `Intl` zet tussen het euroteken en het bedrag
 * een harde spatie (U+00A0).
 */
import type { WerkplekKlantOrder } from "../api";

const GELD = new Intl.NumberFormat("nl-NL", { style: "currency", currency: "EUR" });

export function euro(cents: number | null | undefined): string {
  if (cents === null || cents === undefined) return "";
  return GELD.format(cents / 100);
}

/** ISO-moment naar "23-09" (dag en maand, Amsterdam). */
export function dagMaand(iso: string | null | undefined): string {
  if (!iso) return "";
  const moment = new Date(iso);
  if (Number.isNaN(moment.getTime())) return "";
  return moment.toLocaleDateString("nl-NL", {
    timeZone: "Europe/Amsterdam",
    day: "2-digit",
    month: "2-digit",
  });
}

/** Het jaartal van een ISO-moment of datum, of null. */
export function jaar(iso: string | null | undefined): number | null {
  if (!iso) return null;
  const moment = new Date(iso);
  if (Number.isNaN(moment.getTime())) return null;
  return Number(
    moment.toLocaleDateString("nl-NL", { timeZone: "Europe/Amsterdam", year: "numeric" }),
  );
}

/** Een href alleen als die met https:// begint; anders geen link. */
export function veiligeLink(url: string | null | undefined): string | null {
  const schoon = url?.trim();
  if (!schoon || !schoon.startsWith("https://")) return null;
  return schoon;
}

/**
 * De Lightspeed-link van een order, zoals v4 hem gebruikt: de backend
 * bouwt hem uit het ordersjabloon en stuurt hem mee. Zonder sjabloon of
 * zonder Lightspeed-id is er geen link, dan staat het ordernummer los.
 */
export function lightspeedLink(order: WerkplekKlantOrder): string | null {
  return veiligeLink(order.lightspeed_url);
}

/** Waarop een koppelvoorstel steunt, in woorden. */
export function matchWoord(matchType: string): string {
  switch (matchType) {
    case "email":
    case "email_in_body":
    case "afzender_email":
      return "e-mailadres";
    case "telefoonnummer":
      return "telefoonnummer";
    case "whatsapp":
      return "WhatsApp-nummer";
    case "ordernummer":
      return "ordernummer";
    case "postcode_huisnummer":
      return "postcode en huisnummer";
    case "huisdiernaam":
      return "naam van het dier";
    case "afzender_naam":
    case "naam":
    case "naam_postcode":
      return "naam en postcode";
    default:
      return matchType.replace(/_/g, " ");
  }
}

export function kanaalWoord(kanaal: string): string {
  switch (kanaal) {
    case "mail":
    case "email":
      return "mail";
    case "chat":
      return "chat";
    case "whatsapp":
      return "WhatsApp";
    case "telefoon":
    case "voicemail":
      return "telefoon";
    default:
      return kanaal;
  }
}

export function wieWoord(doorSoort: string): string {
  switch (doorSoort) {
    case "jp":
      return "jij";
    case "sanne":
      return "Sanne";
    case "nova":
      return "Nova";
    case "klant":
      return "klant";
    case "systeem":
      return "systeem";
    default:
      return doorSoort;
  }
}
